














import Vue, { PropType } from 'vue'
import Message from '@/types/Message.interface'
import Template from '@/types/Template.interface'
export default Vue.extend({
    props: {
        //  The message bound to the message preview
        message: {
            type: Object as PropType<Message>,
            required: true
        }
    },
    data() {
        return {
            //  The v-model for our selected template
            selectedTemplate: null
        }
    },
    mounted() {
        //  If a message template is attached to the message...
        if (this.message.template) {
            //  Set the currently selected template
            this.selectedTemplate = this.message.template

            //  Let the message preview know about the selected template
            this.templateSelected(this.message.template)
        }
    },
    computed: {
        messageTemplates(): Template[] {
            return this.$store.getters.messageTemplates
        }
    },
    methods: {
        templateSelected(template: Template): void {
            //  Forward the selected template to the MessagePreview
            this.$emit('templateSelected', template)
        }
    }
})
